import * as React from 'react';
import Typography from '@mui/material/Typography';
import { Container, Grid, Table, Alert, Snackbar, tableCellClasses, Button, TextField, Modal, Box, IconButton, InputLabel, Select, MenuItem, Dialog, DialogTitle, DialogContent, DialogActions, FormControl } from '@mui/material';
import CloseIcon from "@mui/icons-material/Close";
import { z } from "zod";
import { FormModal, RHFSelect, RHFTextField } from "../components/form";
import { jsPDF } from 'jspdf';
import 'jspdf-autotable';
import { fetchCustomerSupportNewInstallations, updateCustomerSupportNewInstallation, deleteCustomerSupportNewInstallation, emailCustomerSupportNewInstallationPdf, fetchVehicles, fetchCustomers, fetchSolutions, fetchSalesNewInstallation } from "../services/ApiService";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import SendIcon from '@mui/icons-material/Send';
import DeleteConfirmDialog from '../components/DeleteConfirmDialog';
import SendEmailConfirmDialog from '../components/SendEmailConfirmDialog';
import CircularProgress from '@mui/material/CircularProgress';
import DataTable from '../components/DataTable';

export function CustomerSupportNewInstallation() {
  const [haulierOptions, setHaulierOptions] = React.useState([]);
  const [truckOptions, setTruckOptions] = React.useState([]);
  const [devicesOptions, setDevicesOptions] = React.useState([]); const [sendingEmailId, setSendingEmailId] = React.useState(null);
  const [selectedSale, setSelectedSale] = React.useState(null);
  const [saleModalOpen, setSaleModalOpen] = React.useState(false);
  const [snackbar, setSnackbar] = React.useState({ open: false, message: '', severity: 'success' }); // Snackbar state
  const [searchVehicle, setSearchVehicle] = React.useState('');
  const [deleteConfirmOpen, setDeleteConfirmOpen] = React.useState(false);
const [sendConfirmOpen, setSendConfirmOpen] = React.useState(false);
const [selectedActionSaleId, setSelectedActionSaleId] = React.useState(null);

// Open delete confirmation
const handleDeleteClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setDeleteConfirmOpen(true);
};

// Confirm delete
const confirmDelete = async () => {
    if (selectedActionSaleId) {
        await handleDelete(selectedActionSaleId);
    }
    setDeleteConfirmOpen(false);
    setSelectedActionSaleId(null);
};

// Open send email confirmation
const handleSendClick = (saleId) => {
    setSelectedActionSaleId(saleId);
    setSendConfirmOpen(true);
};

// Confirm send email
const confirmSendEmail = async () => {
    if (selectedActionSaleId) {
        await handleSendEmail(selectedActionSaleId);
    }
    setSendConfirmOpen(false);
    setSelectedActionSaleId(null);
};


  const fetchTrucks = async () => {
    try {
      const response = await fetchCustomerSupportNewInstallations();
      const haulierDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.customer;
        return acc;
      }, {});
      console.log(haulierDict);
      setCustomer(haulierDict)
      console.log(response.data);

      setCustomerSupportData(response.data);
      showSnackbar('Customer Support fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching Customer Support Data';
      showSnackbar(`Failed to fetch Customer Support Data: ${errorMessage}`, 'error');
    }
  };
  const fetchTruck = async () => {
    try {
      const response = await fetchVehicles();
      const haulierDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.registration_number;
        return acc;
      }, {});
      setTruckOptions(haulierDict)
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };
  const fetchHauliers = async () => {
    try {
      const response = await fetchCustomers();
      const haulierDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
      setHaulierOptions(haulierDict)
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };
  const fetchDevices = async () => {
    try {
      const response = await fetchSolutions();
      const deviceDict = response.data.reduce((acc, item) => {
        acc[item.id] = item.name;
        return acc;
      }, {});
      setDevicesOptions(deviceDict)
      showSnackbar('Hauliers fetched successfully', 'success');
    } catch (error) {
      const errorMessage =
        error.response?.statusText || error.message || 'Error fetching hauliers';
      showSnackbar(`Failed to fetch hauliers: ${errorMessage}`, 'error');
    }
  };
  const handleSendEmail = async (saleId) => {
    setSendingEmailId(saleId);

    try {
      await emailCustomerSupportNewInstallationPdf(saleId, {});
      alert("Email sent successfully!");
    } catch (error) {
      console.error("Email error:", error);
      alert("Failed to send email.");
    } finally {
      setSendingEmailId(null);
    }
  };
  React.useEffect(() => {
    fetchTrucks();
    fetchHauliers()
    fetchDevices()
    fetchTruck();
  }, []);
  const showSnackbar = (message, severity) => {
    setSnackbar({ open: true, message, severity });
  };
  const handleSnackbarClose = () => {
    setSnackbar({ ...snackbar, open: false });
  };
  const [customerSupportData, setCustomerSupportData] = React.useState([])
  React.useEffect(() => {
    localStorage.setItem('customerSupport', JSON.stringify(customerSupportData));
    console.log(customerSupportData, 'customerSupportData');

  }, [customerSupportData]);
  const [editModalOpen, setEditModalOpen] = React.useState(false);
  const [selectedCustomerSupport, setSelectedCustomerSupport] = React.useState(null);
  const [customer, setCustomer] = React.useState([]);

  const handleEditOn = (device) => {
    setSelectedCustomerSupport(device);
    setCustomer(device.customer)
    setEditModalOpen(true);
  };

  const handleEditClose = () => {
    setEditModalOpen(false);
    setSelectedCustomerSupport(null);
  };


  const handleDelete = async (id) => {
    try {
      await deleteCustomerSupportNewInstallation(id);
      showSnackbar("Customer deleted successfully", "success");
    } catch (error) {
      showSnackbar("Failed to delete customer", "error");
      console.error(error);
    }
  };
  const handleExport = () => {
    const doc = new jsPDF('l', 'mm', 'a3'); // Landscape A3

    // Title
    doc.setFontSize(18);
    doc.text('Customer Support New Installation Report', 14, 16);

    // Columns matching your Material UI table
    const columns = [
      'Support #',
      'Sale #',
      'Vehicle',
      'Location',
      'Remarks',
      'Document',
      'Close At',
    ];

    // Rows aligned with your table
    const tableData = customerSupportData.map((sale) => [
      sale.id,
      sale.sale?.id || '',
      truckOptions[sale.vehicle_details?.id] || '',
      sale.location || '',
      sale.remarks || '',
      sale.document_url ? 'Available' : 'Not Available',
      sale.status === 'Complete'
        ? sale.updated_at?.slice(0, 19).replace('T', ' ')
        : '',
    ]);

    // Generate table
    doc.autoTable({
      head: [columns],
      body: tableData,
      startY: 30,
      styles: {
        fontSize: 9,
        cellPadding: 2,
      },
      columnStyles: {
        0: { cellWidth: 25 },  // Support #
        1: { cellWidth: 25 },  // Sale #
        2: { cellWidth: 40 },  // Vehicle
        3: { cellWidth: 40 },  // Location
        4: { cellWidth: 50 },  // Remarks
        5: { cellWidth: 30 },  // Document
        6: { cellWidth: 40 },  // Close At
      },
      theme: 'grid',
    });

    doc.save('Customer_Support_New_Installation_Report.pdf');
  };
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: { xs: "92vw", sm: 400 },
    bgcolor: "background.",
    boxShadow: "0 20px 60px rgba(0,0,0,0.3)",
  borderRadius: 3,
  maxHeight: "90vh",
  overflowY: "auto",
    p: 4,
  };

  const updateCustomerSupport = async (updatedCustomerSupport, id) => {
    const formData = new FormData();
    for (const key in updatedCustomerSupport) {
      formData.append(key, updatedCustomerSupport[key]);
    }
    try {
      await updateCustomerSupportNewInstallation(id, formData);
      showSnackbar('Customer Support updated successfully', 'success');
    } catch (error) {
      showSnackbar('Failed to update device', 'error');
    }
  };
  const handleStatusChange = async (saleId, newStatus, sale) => {
    const updatedSale = { ...sale, status: newStatus };

    try {
      await updateCustomerSupportNewInstallation(saleId, updatedSale);

      // Update state in frontend
      setCustomerSupportData((prevData) =>
        prevData.map((item) =>
          item.id === saleId ? { ...item, status: newStatus } : item
        )
      );
      showSnackbar('Status updated successfully', 'success');
    } catch (error) {
      console.error('Failed to update status:', error);
      showSnackbar('Failed to update status', 'error');
    }
  };
  const handleViewSaleDetail = async (saleId) => {
    try {
      const response = await fetchSalesNewInstallation(saleId);
      console.log(response.data);
      setSelectedSale(response.data);
      setSaleModalOpen(true);
    } catch (error) {
      console.error("Failed to fetch sale detail:", error);
    }
  };

  const filteredCustomerSupportData = searchVehicle
    ? customerSupportData.filter((sale) =>
      truckOptions[sale.vehicle_details?.id]
        ?.toLowerCase()
        .includes(searchVehicle.toLowerCase())
    )
    : customerSupportData;

  return (
    <Container maxWidth="xl" sx={{ m: 2 }}>
      {editModalOpen && selectedCustomerSupport && <EditCustomerSupportModal
        open={editModalOpen}
        handleClose={handleEditClose}
        device={selectedCustomerSupport}
        customer={customer}
        showSnackbar={showSnackbar}
        fetchTrucks={fetchTrucks}
      />}
      <DataTable
        title="Customer Support New Installation List"
        columns={[
          { key: 'id', label: 'Support #' },
          { key: 'sale', label: 'Sale #', render: (sale) => (
            <span onClick={() => handleViewSaleDetail(sale.sale.id)} style={{ color: '#1976d2', textDecoration: 'underline', cursor: 'pointer' }}>{sale.sale.id}</span>
          )},
          { key: 'customer', label: 'Customer', render: (sale) => haulierOptions[sale.customer] },
          { key: 'vehicle', label: 'Vehicle', render: (sale) => truckOptions[sale.vehicle_details?.id] },
          { key: 'location', label: 'Location' },
          { key: 'remarks', label: 'Remarks' },
          { key: 'document_url', label: 'Document', render: (sale) => sale.document_url ? (
            <a href={`https://crm-backend.monit.tech/${sale.document_url}`} download target="_blank" rel="noopener noreferrer">Download</a>
          ) : <span style={{ color: '#999' }}>Not Available</span> },
          { key: 'close_at', label: 'Close At', render: (sale) => (
            <div style={{ maxHeight: '80px', overflow: 'auto' }}>{sale.status === 'Complete' && sale.updated_at?.slice(0, 19).replace("T", " ")}</div>
          )},
        ]}
        rows={filteredCustomerSupportData}
        toolbarActions={<>
          <TextField size="small" placeholder="Search Vehicle..." value={searchVehicle} onChange={(e) => setSearchVehicle(e.target.value)} />
          <Button variant="contained" color="primary" style={{ marginLeft: "10px" }} onClick={handleExport}>Export to PDF</Button>
        </>}
        renderActions={(sale) => <>
          <IconButton color="secondary" size="small" onClick={() => handleEditOn(sale)} sx={{ padding: '6px' }} disabled={sale.status === 'Complete'}><EditIcon /></IconButton>
          <IconButton color="error" size="small" onClick={() => handleDeleteClick(sale.id)} sx={{ padding: '6px', marginLeft: '4px' }} disabled={sale.status === 'Complete'}><DeleteIcon /></IconButton>
          <IconButton color="primary" size="small" onClick={() => handleSendClick(sale.id)} sx={{ padding: '6px', marginLeft: '4px' }} disabled={sendingEmailId === sale.id}>
            {sendingEmailId === sale.id ? <CircularProgress size={20} color="inherit" /> : <SendIcon />}
          </IconButton>
          <Select value={sale.status} onChange={(e) => handleStatusChange(sale.id, e.target.value, sale)} size="small" sx={{ ml: 1, minWidth: 100 }}>
            <MenuItem value="Pending">Pending</MenuItem>
            <MenuItem value="Complete">Complete</MenuItem>
          </Select>
        </>}
      />
          {/* Delete Confirmation */ }
      <DeleteConfirmDialog
        open={deleteConfirmOpen}
        onClose={() => setDeleteConfirmOpen(false)}
        onConfirm={confirmDelete}
      />

      <SendEmailConfirmDialog
        open={sendConfirmOpen}
        onClose={() => setSendConfirmOpen(false)}
        onConfirm={confirmSendEmail}
      />
      <Dialog open={saleModalOpen} onClose={() => setSaleModalOpen(false)} maxWidth="sm" fullWidth>
        <DialogTitle>Sale Details</DialogTitle>
        <DialogContent>
          {selectedSale ? (
            <Box>
              <Typography variant="body1"><strong>Customer:</strong> {haulierOptions[selectedSale.customer]}</Typography>
              <Typography variant="body1"><strong>Solution:</strong> {devicesOptions[selectedSale.solution]}</Typography>
              <Typography variant="body1"><strong>Corporate:</strong> {selectedSale.corporate}</Typography>
              <Typography variant="body1"><strong>POC Name:</strong> {selectedSale.poc_name}</Typography>
              <Typography variant="body1"><strong>POC Contact:</strong> {selectedSale.poc_contact}</Typography>
              <Typography variant="body1"><strong>Plan:</strong> {selectedSale.plan}</Typography>
              <Typography variant="body1"><strong>Unit:</strong> {selectedSale.unit}</Typography>
              <Typography variant="body1"><strong>Features:</strong> {selectedSale.features}</Typography>

            </Box>
          ) : (
            <Typography variant="body2">Loading...</Typography>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setSaleModalOpen(false)} color="primary">Close</Button>
        </DialogActions>
      </Dialog>

      <Snackbar
        open={snackbar.open}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbar.severity} sx={{ width: '100%' }}>
          {snackbar.message}
        </Alert>
      </Snackbar>
    </Container>
  );
}



const editSchema = z.object({
  vehicle:  z.string().min(1, "Vehicle is required"),
  location: z.string().min(1, "Location is required"),
  remarks:  z.string().optional(),
});

const EditCustomerSupportModal = ({
  open,
  handleClose,
  device,
  customer,
  showSnackbar,
  fetchTrucks,
}) => {
  const [trucks, setTrucks] = React.useState({});

  React.useEffect(() => {
    if (!customer) return;
    fetchVehicles(customer).then((res) => {
      setTrucks(res.data.reduce((acc, v) => ({ ...acc, [v.id]: v.registration_number }), {}));
    }).catch(console.error);
  }, [customer]);

  const defaultValues = {
    vehicle:  String(device?.vehicle_details?.id ?? ""),
    location: device?.location ?? "",
    remarks:  device?.remarks ?? "",
  };

  const handleSubmit = async (data) => {
    const fd = new FormData();
    Object.entries(data).forEach(([k, v]) => fd.append(k, v));
    try {
      await updateCustomerSupportNewInstallation(device.id, fd);
      showSnackbar("Customer Support updated successfully", "success");
      fetchTrucks();
    } catch (error) {
      showSnackbar("Failed to update", "error");
      throw error; // keeps modal open
    }
  };

  return (
    <FormModal
      open={open}
      onClose={handleClose}
      title="Edit Customer Support"
      schema={editSchema}
      defaultValues={defaultValues}
      onSubmit={handleSubmit}
      submitLabel="Update"
      width={520}
    >
      {({ control }) => (
        <>
          {/* Timestamps bar */}
          <Box sx={{ mb: 2.5, pb: 1.5, borderBottom: "1px solid", borderColor: "divider", display: "flex", gap: 3, flexWrap: "wrap" }}>
            <Typography variant="caption" color="text.secondary">
              Created: {device?.created_at?.slice(0, 19).replace("T", " ")}
            </Typography>
            <Typography variant="caption" color="text.secondary">
              Updated: {device?.updated_at?.slice(0, 19).replace("T", " ")}
            </Typography>
          </Box>

          <Grid container spacing={2.5}>
            <Grid item xs={12} md={6}>
              <RHFSelect control={control} name="vehicle" label="Vehicle" options={trucks} required />
            </Grid>
            <Grid item xs={12} md={6}>
              <RHFTextField control={control} name="location" label="Location" required />
            </Grid>
            <Grid item xs={12}>
              <RHFTextField control={control} name="remarks" label="Remarks" multiline rows={3} />
            </Grid>
          </Grid>
        </>
      )}
    </FormModal>
  );
};

export default EditCustomerSupportModal;

